import config from './config.json';

export const getConfig = () => {
  return config;
};

export const getApiUrl = () => {
  return config.API_URL;
};

// Add other config getters as needed
//export const getOtherConfig = () => {
  //return config.otherConfig;
//};

export const hebrewLetters = [
  "א", "ב", "ג", "ד", "ה", "ו", "ז", "ח", "ט", "י",
  "יא", "יב", "יג", "יד", "טו", "טז", "טח"
];